import { Styles } from "@mcleod/core";

export const DesignerToolsTableCellStyles = Styles.make("tdd", () => {
    return {
        base: {
            display: "table-cell",
            overflow: "hidden",
            paddingBottom: "0px",
            paddingLeft: "2px",
            paddingRight: "2px",
            paddingTop: "0px",
            verticalAlign: "middle"
        }
    }
});
